import { combineReducers } from 'redux';

import loading from './loading';
import bcts from './bcts';
import layout from './layout';

export default combineReducers({
    loading,
    bcts,
    layout,
});
